<template>
    <CodiceFeanorView tool-module="johnDictionaries" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
